import { IComponentOptions } from "angular";
import { RelationshipGridController } from "./controller";

export const vsComponentName = "relationshipGridComponent";

export const relationshipGridComponentOptions: IComponentOptions = {
  controller: RelationshipGridController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
